<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Weitere Informationen</p>
    </header>
    <section class="modal-card-body">
      <div class="content" v-html="content" />
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$emit('close')">
        Schliessen
      </button>
    </footer>
  </div>
</template>

<script setup lang="ts">
defineProps({
  content: {
    type: String,
    default: '',
  },
})

defineBlokkli({
  bundle: 'price',
})

defineEmits(['close'])

// You can add any other logic or functions here
</script>
